import React from 'react';
import { ButtonLink } from '../../../../components/ButtonLink';
import { statesData } from '../../../../data/states';
import { buildCols } from '../../../../utils/buildCols';
import { ColumnList, ColumnListProps } from '../../../../wag-react/components/ColumnList';
const createStateUrl = (state: string) => `/${state.toLowerCase()}`;
type Props = Omit<ColumnListProps, 'cols'>;
export type StatesColumnListProps = Props;
const items = statesData.map(({
  stateAbbrev,
  state
}) => <ButtonLink key={stateAbbrev} color="medGray" href={createStateUrl(stateAbbrev)} fontSize={['mobile-body1', 'tablet-body1', 'desktop-body1']} lineHeight="1.75" justifyContent="flex-start">
    {state}
  </ButtonLink>);
export const StatesColumnList = (props: Props) => {
  const cols = buildCols(2, items);
  return <ColumnList {...props} cols={cols} data-sentry-element="ColumnList" data-sentry-component="StatesColumnList" data-sentry-source-file="StatesColumnList.tsx" />;
};